import { Badge } from "@/components/ui/badge";

import { snapshotLine, TONE_CLASS, type StrategySnapshot } from "./strategies";

/**
 * C1 v1.14 (owner ruling 2026-09-29): the rule-verdict snapshot of one Price Log entry in one line, "<strategy> · <n of m
 * rules met> · goal <status>", the summary toned as the Price Run chip is; or the one sentence that says why there is
 * none. The Logs Price pane (under Source) and the drawer's Price history (under the latest entry) share it. It wraps
 * (`whitespace-normal`): a table cell is `whitespace-nowrap`, and the line would push the pane off the screen.
 */
export function SnapshotLine({ snapshot }: { snapshot: StrategySnapshot | null }) {
  const l = snapshotLine(snapshot);
  if (!l.name) return <div className="whitespace-normal text-xs text-ks-grey-1">{l.note}</div>;
  return (
    <div className="whitespace-normal text-xs">
      <span className="text-ks-ink">{l.name}</span>
      {l.note && <span className="text-ks-grey-1"> · {l.note}</span>}
      {l.summary && <> · {l.tone ? <Badge variant="outline" className={TONE_CLASS[l.tone]}>{l.summary}</Badge> : <span className="text-ks-grey-1">{l.summary}</span>}</>}
      {l.goal && <span className="text-ks-grey-1" title={l.goalTitle ?? undefined}> · {l.goal}</span>}
    </div>
  );
}
